/* global maplibregl */
/* eslint-disable no-new */

export default class Mapbox {
  constructor(geojsonData, longitude, latitude, zoomLevel, containerId = 'poi-map', forceZoomLevel = 0) {
    const mapContainer = document.querySelector(`#${containerId}`);
    let scrollEnabled = false;
    const geojson = geojsonData;

    const map = new maplibregl.Map({
      container: containerId,
      style: 'https://tiles.openfreemap.org/styles/bright',
      center: [longitude, latitude],
      zoom: zoomLevel,
      scrollZoom: false
    });

    map.addControl(new maplibregl.NavigationControl(), 'bottom-right');

    if (window.innerWidth <= 800) {
      map.doubleClickZoom.enable();
      map.dragPan.disable();
    } else {
      map.doubleClickZoom.disable();
      map.dragPan.enable();
    }

    mapContainer.addEventListener('click', () => {
      if (scrollEnabled) {
        map.scrollZoom.disable();
        scrollEnabled = false;
      } else {
        map.scrollZoom.enable();
        scrollEnabled = true;
      }
    });

    map.on('load', () => {
      map.getStyle().layers.forEach(layer => {
        if (layer.layout && layer.layout['text-field']) {
          if (JSON.stringify(layer.layout['text-field']).includes('"name"')) {
            map.setLayoutProperty(layer.id, 'text-field', ['coalesce', ['get', 'name:nl'], ['get', 'name']]);
          }
        }
      });

      const bounds = new maplibregl.LngLatBounds();
      geojson.features.forEach((feature) => {
        const [lng, lat] = feature.geometry.coordinates;
        bounds.extend([lng, lat]);
      });

      if (forceZoomLevel <= 0 && !bounds.isEmpty()) {
        map.fitBounds(bounds, { padding: 100 });
      }

      geojson.features.forEach((marker) => {
        const [lng, lat] = marker.geometry.coordinates;
        const isHome = marker.properties.className === 'marker-woning';
        const width = isHome ? 40 : 30;
        const height = isHome ? 55 : 40;

        const el = document.createElement('div');
        el.className = `${marker.properties.className} marker`;
        el.style.width = `${width}px`;
        el.style.height = `${height}px`;

        if (marker.properties.iconImage) {
          el.style.backgroundImage = marker.properties.iconImage;
          el.style.backgroundSize = '100%';
        }

        const popup = new maplibregl.Popup({
          closeButton: false,
          className: 'map-popup-box',
          offset: [0, -height]
        }).setHTML(`<span>${marker.properties.title}</span>`);

        new maplibregl.Marker({ element: el, anchor: 'bottom' })
          .setLngLat([lng, lat])
          .setPopup(popup)
          .addTo(map);
      });
    });
  }
}
